import React from 'react';

function JSONLD({ data }) {
  return (
    <script type="application/ld+json">
      {JSON.stringify(data)}
    </script>
  );
}
export default JSONLD;
